/* Core & libraries */
import React, { useEffect, useState, useRef } from "react";

/* Helpers, constants, custom methods, internal libraries */

/* Components */
import DeltaJoinProgramContent from "../../components/deltaJoinProgramContent/index.js";

/* Styles */
import styles from "./styles.js"

const DeltaJoinProgramPage = () => {
    return (
        <div className="program-page">
            <DeltaJoinProgramContent />
        </div>
    )
}

export default DeltaJoinProgramPage;
